// https://raw.githubusercontent.com/EmilTholin/gmail-api-parse-message/
var b64Decode = require('base-64').decode;
var querystring = require('querystring');

/**
 * Decodes a url safe Base64 string to its original representation.
 * @param  {string} string
 * @return {string}
 */
function urlB64Decode(string) {
  return string
    ? decodeURIComponent(escape(b64Decode(string.replace(/\-/g, '+').replace(/\_/g, '/'))))
    : '';
}

/**
 * Takes the header array filled with objects and transforms it into a more
 * pleasant key-value object.
 * @param  {array} headers
 * @return {object}
 */
function indexHeaders(headers) {
  if (!headers) {
    return {};
  } else {
    return headers.reduce(function (result, header) {
      result[header.name.toLowerCase()] = header.value;
      return result;
    }, {});
  }
}

function parsePart(part) {
  var p = part.substring(part.indexOf("{"), part.lastIndexOf("}") + 1);
  return JSON.parse(p);
}

module.exports = {
  /**
   * Takes an array of API call objects and generates a string that can be used
   * as the body in a call to Google batch API.
   * @param  {object[]} apiCalls
   * @param  {string}   apiCalls[].uri      - Uri of the API call.
   * @param  {string}   apiCalls[].[method] - Optional HTTP method. Defaults to GET.
   * @param  {object}   apiCalls[].[qs]     - Optional object with querystring parameters.
   * @param  {string}   apiCalls[].[body]   - Optional request body string.
   * @param  {string}   boundary            - String that delimits the calls.
   * @return {string}
   */
  createBatchBody: function(apiCalls, boundary) {
    var batchBody = [];

    apiCalls.forEach(function(call) {
      var method = call.method || 'GET';
      var uri = call.uri;
      if (call.qs) {
        uri += '?' + querystring.stringify(call.qs);
      }
      var body = '\r\n';
      if (call.body) {
        body = [
          'Content-Type: application/json', '\r\n\r\n',

          JSON.stringify(call.body), '\r\n'
        ].join('');
      }

      batchBody = batchBody.concat([
        '--', boundary, '\r\n',
        'Content-Type: application/http', '\r\n\r\n',

        method, ' ', uri, '\r\n',
        body
      ]);
    });

    return batchBody.concat(['--', boundary, '--']).join('');
  },

  /**
   * Parses a raw string response from the Google batch API into objects.
   * @param  {string} response
   * @return {object[]}
   */
  parseBatchResponse: function(response, headers) {
    // Not the same delimiter in the response as was specified in the request,
    // so we have to extract it.
    const ct = headers.get('Content-Type');
    const identifier = 'boundary=';
    var delimiter = `--${ct.substring(ct.indexOf(identifier) + 9, ct.length)}`;
    var parts = response.split(delimiter);
    // The first part will always be an empty string. Just remove it.
    parts.shift();
    // The last part will be the "--". Just remove it.
    parts.pop();

    var result = [];
    for (var i = 0; i < parts.length; i++) {
      var part = parts[i];
      try {
        result.push(parsePart(part));
      } catch (e) {
        console.error(e);
        // A Google API error will contain a JSON response with an array 'errors'.
        // If the parsing should fail, we mimic this.
        result.push({ errors: [{ message: part }] });
      }
    }

    return result;
  },

  /**
   * Takes a response from the Gmail API's GET message method and extracts all
   * the relevant data.
   * @param  {object} response
   * @return {object}
   */
  parseMessage: function parseMessage(response) {
    var result = {
      id: response.id,
      threadId: response.threadId,
      labelIds: response.labelIds,
      snippet: response.snippet,
      historyId: response.historyId
    };
    if (response.internalDate) {
      result.internalDate = parseInt(response.internalDate);
    }

    var payload = response.payload;
    if (!payload) {
      return result;
    }

    var headers = indexHeaders(payload.headers);
    result.headers = headers;

    var parts = [payload];
    var firstPartProcessed = false;

    while (parts.length !== 0) {
      var part = parts.shift();
      if (part.parts) {
        parts = parts.concat(part.parts);
      }
      if (firstPartProcessed) {
        headers = indexHeaders(part.headers);
      }

      if (!part.body) {
        continue;
      }

      var isHtml = part.mimeType && part.mimeType.indexOf('text/html') !== -1;
      var isPlain = part.mimeType && part.mimeType.indexOf('text/plain') !== -1;
      var isAttachment = headers['content-disposition'] && headers['content-disposition'].indexOf('attachment') !== -1;
      var isInline = headers['content-disposition'] && headers['content-disposition'].indexOf('inline') !== -1;

      if (isHtml && !isAttachment) {
        result.textHtml = urlB64Decode(part.body.data);
      } else if (isPlain && !isAttachment) {
        result.textPlain = urlB64Decode(part.body.data);
      } else if (isAttachment) {
        var body = part.body;
        if(!result.attachments) {
          result.attachments = [];
        }
        result.attachments.push({
          filename: part.filename,
          mimeType: part.mimeType,
          size: body.size,
          attachmentId: body.attachmentId,
          headers: indexHeaders(part.headers)
        });
      } else if (isInline) {
        var body = part.body;
        if(!result.inline) {
          result.inline = [];
        }
        result.inline.push({
          filename: part.filename,
          mimeType: part.mimeType,
          size: body.size,
          attachmentId: body.attachmentId,
          headers: indexHeaders(part.headers)
        });
      }

      firstPartProcessed = true;
    }

    return result;
  }
};



// WEBPACK FOOTER //
// ./src/_helpers/gmail.js